.bar {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 9999px;
  display: inline-flex;
  gap: 8px;
  padding: 4px;
  width: fit-content;
}

// Narrow viewports: contain the bar to its parent and scroll horizontally
// rather than clipping the trailing tabs. Desktop is unchanged (fit-content
// stays under the max-width so no scrollbar appears).
.scrollable {
  max-width: 100%;
  // Allow the bar to shrink below its content width inside a flex parent so
  // the overflow actually scrolls instead of pushing the row wider.
  min-width: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 4px;
  }
}

.tab {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 9999px;
  color: var(--color-foreground);
  cursor: pointer;
  display: inline-flex;
  // Don't squish tabs in a scrollable bar — overflow scrolls instead.
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  height: 40px;
  padding: 8px;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;

  &.isActive {
    background: var(--color-secondary);
  }

  &.isDisabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    border-color: var(--color-foreground);
  }
}

// Compact variant for dense toolbars (declared after `.tab` so it wins).
.tab-sm {
  font-size: 13px;
  gap: 6px;
  height: 32px;
  padding: 5px 11px;
}
